class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

 renderContents(parsedState) {
  this.productId = parsedState.id;
  this.getSectionsToRender().forEach((section => {
    if (document.getElementById(section.id)) {
      document.getElementById(section.id).innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }
  }));

  this.open();

  // Always dispatch drawer open event for GWP logic
  document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
}

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart); 

/* sample picker free product removal if order reduced logic */
/*

(() => {
  const MIN_REAL_ITEMS = 2;     // require 2+ real products
  let sweeping = false;

  // Count real (non-gift) quantity from the drawer DOM
  function countRealFromDOM() {
    let total = 0;
    document.querySelectorAll('#mini-cart .mini-cart__navigation > li').forEach(li => {
      const isGift = String(li.getAttribute('data-gift-hidden')) === 'true';
      const qty = parseInt(li.getAttribute('data-quantity') || '0', 10);
      if (!isGift) total += qty;
    });
    return total;
  }

  // Collect variant IDs of gift-hidden lines from the drawer DOM
  function collectGiftVariantIds() {
    const ids = [];
    document.querySelectorAll('#mini-cart .mini-cart__navigation > li').forEach(li => {
      if (String(li.getAttribute('data-gift-hidden')) === 'true') {
        const vid = li.getAttribute('data-variant-id');
        if (vid) ids.push(vid);
      }
    });
    return ids;
  }

  // Remove many lines at once
  async function removeVariants(variantIds) {
    if (!variantIds.length) return;
    const updates = {};
    variantIds.forEach(id => updates[id] = 0);
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type':'application/json', 'Accept':'application/json' },
      body: JSON.stringify({ updates })
    });
  }

  // Refresh drawer using your component
  async function refreshDrawer() {
    const res = await fetch('/?sections=mini-cart,cart-icon-bubble,mobile-cart-icon-bubble');
    const sections = await res.json();
    const mini = document.querySelector('mini-cart');
    if (mini && typeof mini.renderContents === 'function') {
      mini.renderContents({ id: String(Date.now()), sections });
    } else {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail:{ source:'freebie-auto' }}));
      document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
    }
  }

  // Fast sweep: if ineligible, nuke freebies in one shot and refresh
  async function sweepFreebiesIfNeeded() {
    if (sweeping) return;
    sweeping = true;
    try {
      const realQty = countRealFromDOM();
      if (realQty >= MIN_REAL_ITEMS) return;

      const giftIds = collectGiftVariantIds();
      if (!giftIds.length) return;

      await removeVariants(giftIds);
      await refreshDrawer();
    } catch (e) {
      console.error('[FreebieAuto] sweep error', e);
    } finally {
      sweeping = false;
    }
  }

  // Run when the drawer opens (your component dispatches this)
  document.addEventListener('cartdrawer:opened', sweepFreebiesIfNeeded);

  // Re-run when the drawer DOM changes (quantities, adds, etc.)
  const mo = new MutationObserver(() => sweepFreebiesIfNeeded());
  mo.observe(document.getElementById('mini-cart') || document.documentElement, { childList:true, subtree:true });

  // First pass
  document.addEventListener('DOMContentLoaded', sweepFreebiesIfNeeded);
})();


*/